import { useContext } from 'react';
import { VisitorContext } from './visitorContext';

export function useVisitor() {
  return useContext(VisitorContext);
}
